export default __webpack_public_path__ + "static/media/p5.b0cb1215.jpeg";